import React, { Fragment, useState } from 'react';
import Error from './Error'
import PropTypes from 'prop-types';

const Question = ({ saveBudget, saveRemaining, updateShowQuestion }) => {

    //definir el state
    const [quantity, setQuantity] = useState(0);
    const [error, updateError] = useState(false);

    // funcion que lee el presupuesto 
    const defineBudget = e => {
        // console.log(parseInt(e.target.value, 10))
        setQuantity(parseInt(e.target.value, 10))
    }

    // submit para definir el presupuesto
    const addBudget = e => {
        e.preventDefault();

        //validar input 
        if (quantity < 1 || isNaN(quantity)) {
            updateError(true);
            return;
        }
        // si pasa la valdiacion
        updateError(false);
        saveBudget(quantity);
        saveRemaining(quantity);
        updateShowQuestion(false);
    }


    return (
        <Fragment>
            <h2>Coloca tu presupuesto</h2>

            {error ? <Error message="El Presupuesto es incorrecto" /> : null}

            <form
                onSubmit={addBudget}
            >
                <input
                    type="number"
                    className="u-full-width"
                    placeholder="Coloca tu presupuesto"
                    onChange={defineBudget}
                />

                <input
                    type="submit"
                    className="button-primary u-full-width"
                    placeholder="Definir presupuesto"
                />
            </form>
        </Fragment>
    );
}

Question.propTypes = {
    saveBudget: PropTypes.func.isRequired,
    saveRemaining: PropTypes.func.isRequired,
    updateShowQuestion: PropTypes.func.isRequired,
}


export default Question;